// Medicao do "Compre Junto" do mini-cart:
// - evento GA4 compre_junto_click a cada clique em "Adicionar"
// - evento GA4 compre_junto_add quando o produto entra no carrinho
// - propriedade oculta _origem: compre-junto no item (vai junto para o pedido)
(function () {
  var pending = null;

  function track(name, data, variantId) {
    var params = { item_id: data.pid || '', item_name: data.title || '' };
    if (variantId) params.variant_id = String(variantId);
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', name, params);
      } else {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(Object.assign({ event: name }, params));
      }
    } catch (err) {}
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.compre-junto__add-btn');
    if (!btn) return;
    var card = btn.closest('.compre-junto__item');
    var titleEl = card && card.querySelector('.compre-junto__item-title');
    pending = {
      ts: Date.now(),
      pid: btn.getAttribute('data-pid') || '',
      vid: btn.getAttribute('data-needs-select') === 'true' ? '' : (btn.getAttribute('data-vid') || ''),
      title: titleEl ? titleEl.textContent.trim() : ''
    };
    track('compre_junto_click', pending);
  }, true);

  // Se o mini-cart fechar sem a adicao acontecer, descarta o clique pendente
  var miniCart = document.getElementById('miniCart');
  if (miniCart && window.MutationObserver) {
    new MutationObserver(function () {
      if (!miniCart.classList.contains('active')) pending = null;
    }).observe(miniCart, { attributes: true, attributeFilter: ['class'] });
  }

  var origFetch = window.fetch;
  if (typeof origFetch !== 'function') return;

  window.fetch = function (input, init) {
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (pending && url.indexOf('/cart/add.js') !== -1 && init && typeof init.body === 'string') {
        var current = pending;
        pending = null;
        var fresh = Date.now() - current.ts < (current.vid ? 5000 : 60000);
        var body = JSON.parse(init.body);
        if (fresh && body && body.id && (!current.vid || String(body.id) === current.vid)) {
          body.properties = Object.assign({}, body.properties, { _origem: 'compre-junto' });
          init = Object.assign({}, init, { body: JSON.stringify(body) });
          track('compre_junto_add', current, body.id);
        }
      }
    } catch (err) {}
    return origFetch.call(this, input, init);
  };
})();
